import React from 'react';
import { Form, Input, Button } from 'antd';
import { Modal } from 'antd';
import { v4 as uuidv4 } from 'uuid';

interface ValueForm {
  Subject: string;
  Name: string;
  previewText: string;
  Email: string;
}

type BESaveComponentModalProps = {
  show: boolean;
  setShow: (flag: boolean) => void;
};

const BESaveComponentModal = ({
  show,
  setShow
}: BESaveComponentModalProps): JSX.Element => {
  const [form] = Form.useForm();

  const saveRowHandler = (value: ValueForm): void => {
    const metadata = {
      name: value['Name'],
      componentId: uuidv4()
    };
    window.beeHandleMetadata = metadata;
    window.beeSaveResolver(metadata);
    setShow(false);
  };

  return (
    <Modal
      key="save_row"
      title="Save Component"
      style={{ top: '20vh' }}
      open={show}
      footer={[]}
      onCancel={(): void => {
        window.beeSaveRejector();
        setShow(false);
      }}
    >
      <Form
        name="basic"
        form={form}
        onFinish={(value: ValueForm): void => {
          saveRowHandler(value);
        }}
      >
        <p>Name this component so you can reuse it later.</p>
        <Form.Item
          label="Component Name:"
          name="Name"
          rules={[
            {
              required: true,
              message: 'Please input the name'
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BESaveComponentModal;
